import type { DeleteOversightAssessmentsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteOversightAssessmentsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteOversightAssessments = createMutationHook({
  name: 'deleteOversightAssessments',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.oversight.delete.mutationOptions({ onSuccess }),
  mapInput: (ids: string[]) => ({ Ids: ids }),
  invalidate: (trpc) => [
    // COI-889: router-level key — the hand-listed set missed `getById`.
    trpc.frontend.oversight.pathKey(),
  ],
  mapResponse: (result: {
    affected_rows: number;
  }): DeleteOversightAssessmentsMutation => ({
    delete_oversight_assessment: {
      __typename: 'oversight_assessment_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: DeleteOversightAssessmentsDocument,
  graphqlVariables: (ids: string[]) => ({ Ids: ids }),
  // The corresponding READS are NOT migrated and are cache-first, so a write
  // via tRPC still has to evict these or the Apollo-backed list/counter shows
  // pre-write data. Kept identical on both branches so they cannot drift.
  evictFields: ['oversight_assessment', 'oversight_assessment_aggregate'],
});
